import {
	Component, OnInit, OnChanges, SimpleChanges, OnDestroy, Input
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MonitorPolicy, MonitorSettings_Snmp, SnmpMonitorEntry } from 'DiscoveryEngine.TS/Monitors';
import { MessageService } from 'base';
import { MonitorConfigComponentBase } from '../MonitorConfigComponentBase';
import { CustomSnmpMonitorComponentState } from '../customsnmpmonitor/customsnmpmonitor.component';


export class CustomSnmpSettingsListEntry {
	public entryGuid: string;
	public name: string;
	public oid: string;

	public entryTag: SnmpMonitorEntry;
	public get hasEntryTag(): boolean {
		return !!this.entryTag;
	}

	constructor(settingsEntry?: SnmpMonitorEntry) {
		if (!!settingsEntry) {
			this.entryGuid = settingsEntry.Guid.ToString();
			this.name = settingsEntry.Name;
			this.oid = settingsEntry.Oid;

			this.entryTag = settingsEntry;
		}
		else {
			this.entryGuid = "";
			this.name = "";
			this.oid = "";

			this.entryTag = null;
		}
	}
}


@Component({
	selector: 'custom-snmp-settings',
	templateUrl: './customsnmpsettings.component.html',
	styleUrls: ['./customsnmpsettings.component.scss']
})
export class CustomSnmpSettingsComponent extends MonitorConfigComponentBase implements OnInit, OnChanges, OnDestroy {

	@Input()
	public monEditorState: CustomSnmpMonitorComponentState;

	private monPolicy: MonitorPolicy;
	private monSettings: MonitorSettings_Snmp;

	public entries: CustomSnmpSettingsListEntry[];

	public name: UntypedFormControl;
	public enabled: UntypedFormControl;

	public targetEntry: SnmpMonitorEntry;
	public realTargetEntry: SnmpMonitorEntry;
	public isCreate: boolean;
	public displayEntryEditor: boolean;

	constructor(private fb: UntypedFormBuilder,
				private messageService: MessageService) {
		super();

		this.monEditorState = null;

		this.monPolicy = null;
		this.monSettings = null;

		this.entries = [];

		this.name = null;
		this.enabled = null;

		this.resetEditorState();
	}

	private resetEditorState(): void {
		this.targetEntry = null;
		this.realTargetEntry = null;
		this.isCreate = false;
		this.displayEntryEditor = false;
	}

	public ngOnInit(): void {
		this.init();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.init();
	}

	private init(): void {
		this.monPolicy = null;
		this.monSettings = null;
		//this.monEditorState.monEntryCache.Clear();

		if (this.editor) {
			this.monPolicy = this.editor.Policy;
			this.monSettings = <MonitorSettings_Snmp>this.monPolicy.Settings;
			//this.monSettings.GetSnmpMonitorEntries().Values().ForEach((entry: SnmpMonitorEntry) => {
			//	this.monEditorState.monEntryCache.Add(entry.Oid, entry);
			//});;
		}

		this.BuildForm();
	}

	public ngOnDestroy(): void {
		return;
	}

	public BuildForm(): void {
		let name = "";
		let enabled = false;

		if (this.monPolicy) {
			name = this.monPolicy.Name;
			enabled = this.monPolicy.Enabled;
		}

		this.name = new UntypedFormControl(name, Validators.required);
		this.enabled = new UntypedFormControl(enabled);

		this.SettingsForm = this.fb.group({
			name: this.name,
			enabled: this.enabled,
		});

		this.rebuildEntries();
	}

	public applyTempChanges(): void {
		if (this.monPolicy) {
			this.monPolicy.Name = this.name.value;
			this.monPolicy.Enabled = this.enabled.value;

			this.BuildForm();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["Settings"];
	}

	private rebuildEntries(): void {

		this.entries = [];

		if (this.monSettings) {
			this.monSettings.GetGenericEntries().Values().ForEach((snmpEntry: SnmpMonitorEntry) => {
				let listEntry = new CustomSnmpSettingsListEntry(snmpEntry);
				this.entries.push(listEntry);
			});
		}
	}

	public doCustomSort(event): void {
		let comparer = function (a: CustomSnmpSettingsListEntry, b: CustomSnmpSettingsListEntry): number {
			let result = 0;

			switch (event.field) {
				default:
					// Compare string fields
					result = a[event.field].toString().localeCompare(b[event.field].toString());
					break;
			}

			return result * event.order;
		}

		this.entries.sort(comparer);
	}

	public addEntry(): void {
		this.targetEntry = new SnmpMonitorEntry();
		this.targetEntry.PolicyGuid = this.monSettings.MonitorPolicyId;

		this.isCreate = true;
		this.displayEntryEditor = true;
	}

	public editEntry(listEntry: CustomSnmpSettingsListEntry): void {
		this.targetEntry = new SnmpMonitorEntry(listEntry.entryTag);
		this.realTargetEntry = listEntry.entryTag;
		this.isCreate = false;
		this.displayEntryEditor = true;
	}

	public deleteEntry(listEntry: CustomSnmpSettingsListEntry): void {
		this.editor.RemoveSnmpMonitorEntry(listEntry.entryTag);
		this.rebuildEntries();
		this.SettingsForm.markAsDirty();
		this.monEditorState.settingsChange.emit(true);
	}

	public onEditSave(): void {
		let doSave = false;

		if (this.isCreate) {
			if (!this.monSettings.GetGenericEntries().ContainsKey(this.targetEntry.Oid)) {
				doSave = true;
			}
			else {
				this.messageService.displayErrorMessage("An entry with this OID already exists: " + this.targetEntry.Oid);
			}
		}
		else {
			if (this.monSettings.GetGenericEntries().ContainsKey(this.targetEntry.Oid)) {
				if (this.targetEntry.Oid == this.realTargetEntry.Oid) {
					doSave = true;
				}
				else {
					this.messageService.displayErrorMessage("An entry with this OID already exists: " + this.targetEntry.Oid);
				}
			}
			else {
				doSave = true;
			}
		}

		if (doSave) {
			this.editor.AddUpdateSnmpMonitorEntry(this.targetEntry);
			this.rebuildEntries();
			this.SettingsForm.markAsDirty();

			this.monEditorState.settingsChange.emit(true);
		}

		this.resetEditorState();
	}

	public onEditCancel(): void {
		this.resetEditorState();
	}
}
